// Import dependencies
import React, { useState } from "react";
import { NavLink } from "react-router-dom";

// Import motion library
import { motion } from "framer-motion";

// Import lottie components
import Logo from "../Lotties/Logo";

// Import components
import Helmet from "../components/Helmet/Helmet";
import Intro from "../components/Intro/Intro";
import Footer from "../components/Footer/Footer";

// Import styles
import "../PageStyle/Home.css";

// Navigation links
const navLinks = [
  {
    display: "Servicios",
    path: "/services",
    class: "services",
  },

  {
    display: "Proyectos",
    path: "/projects",
    class: "projects",
  },

  {
    display: "Sobre Mi",
    path: "/about",
    class: "about-me",
  },

  {
    display: "Skills",
    path: "/skills",
    class: "skills",
  },
];

const Home = () => {
  // Styles for logo component
  const styleLogo = {
    top: "20%",
    left: "50%",
    marginTop: "-10px",
    marginLeft: "-150px",
  };

  // Styles for intro component
  const styleIntro = {};

  // State for show or hide intro component
  const [show, setShow] = useState(true);

  return (
    <>
      {/* Main Container */}
      <Helmet title="Inicio">
        <div className="bg-bg_light_primary w-[100vw] h-[100vh] overflow-hidden relative">
          {/* Container */}
          <div className="p-8">
            {/* Show or hide intro component */}
            <div
              onClick={() => {
                setShow(!show);
              }}
            >
              {show ? (
                // Logo
                <div
                  className={`w-[17rem] position-absolute logo`}
                  style={show ? styleLogo : styleIntro}
                >
                  <Logo />{" "}
                </div>
              ) : (
                <div className="absolute top-0 bg-gray bottom-0 right-[50%] w-[50%] h-[100%] z-[1] intro">
                  <Intro />
                </div>
              )}
            </div>

            {/* Services */}
            <NavLink
              to={navLinks[0].path}
              className={`${navLinks[0].class} font-Paprika text-sm`}
            >
              <motion.h2
                initial={{
                  y: -200,
                  transition: { type: "spring", duration: 1.5, delay: 1 },
                }}
                animate={{
                  y: 0,
                  transition: { type: "spring", duration: 1.5, delay: 1 },
                }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                {navLinks[0].display}
              </motion.h2>
            </NavLink>

            {/* Projects */}
            <NavLink
              to={navLinks[1].path}
              className={`${navLinks[1].class} font-Paprika`}
            >
              <motion.h2
                initial={{
                  y: -200,
                  transition: { type: "spring", duration: 1.5, delay: 1 },
                }}
                animate={{
                  y: 0,
                  transition: { type: "spring", duration: 1.5, delay: 1 },
                }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                {navLinks[1].display}
              </motion.h2>
            </NavLink>

            <div className="bottom-bar">
              {/* About */}
              <NavLink
                to={navLinks[2].path}
                className={`${navLinks[2].class} font-Paprika`}
              >
                <motion.h2
                  initial={{
                    y: -200,
                    transition: { type: "spring", duration: 1.5, delay: 1 },
                  }}
                  animate={{
                    y: 0,
                    transition: { type: "spring", duration: 1.5, delay: 1 },
                  }}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  {navLinks[2].display}
                </motion.h2>
              </NavLink>

              {/* Skills */}
              <NavLink
                to={navLinks[3].path}
                className={`${navLinks[3].class} font-Paprika`}
              >
                <motion.h2
                  initial={{
                    y: -200,
                    transition: { type: "spring", duration: 1.5, delay: 1 },
                  }}
                  animate={{
                    y: 0,
                    transition: { type: "spring", duration: 1.5, delay: 1 },
                  }}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  {navLinks[3].display}
                </motion.h2>
              </NavLink>
            </div>

            {/* Footer */}
            <Footer />
          </div>
        </div>
      </Helmet>
    </>
  );
};

export default Home;
